import { lazy, Suspense, useMemo, useState } from 'react';
import { Icon } from '../design';
import { useProjects } from '../lib/hooks';
import { detectTime, suggestionLabel } from '../lib/timeDetect';

// Hộp thoại nhắc hẹn nằm trong chunk riêng (cùng bộ với màn Lịch) — chỉ tải khi bấm gợi ý lần đầu.
const EventDialog = lazy(() => import('../work/EventDialog').then((m) => ({ default: m.EventDialog })));

/**
 * Gợi ý tạo nhắc hẹn cá nhân (kiểu Zalo) khi nội dung tin nhắn có thời điểm trong tương lai ("mai 9h họp", "thứ sáu 14:30",
 * "30 phút nữa"). Nhận diện ngay trên máy từ văn bản đã giải mã — không gửi gì lên máy chủ cho tới khi người dùng lưu nhắc hẹn.
 * Nhắc hẹn tạo ra là của riêng người bấm (không gắn cuộc trò chuyện → không báo người khác).
 */
export function ReminderSuggestion({ text, sentAt }: { text: string; sentAt: number }) {
  const projects = useProjects();
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const found = useMemo(() => detectTime(text, new Date(sentAt), new Date()), [text, sentAt]);
  if (!found) return null;
  const title = text.replace(/\s+/g, ' ').trim().slice(0, 200);
  return (
    <>
      <button
        type="button"
        className="ws-remind-suggest"
        data-testid="remind-suggest"
        data-saved={saved || undefined}
        disabled={saved}
        title={`Tạo nhắc hẹn cho riêng bạn từ “${found.matched}”`}
        onClick={() => setOpen(true)}
      >
        <Icon name={saved ? 'check' : 'clock'} size={13} />
        {saved ? 'Đã tạo nhắc hẹn' : `Tạo nhắc hẹn · ${suggestionLabel(found)}`}
      </button>
      {open && (
        <Suspense fallback={null}>
          <EventDialog
            kind="reminder"
            initialTitle={title}
            initialStart={found.at}
            projects={projects}
            onClose={() => setOpen(false)}
            onSaved={() => {
              setOpen(false);
              setSaved(true);
            }}
          />
        </Suspense>
      )}
    </>
  );
}
